import { GridCustomFilterCellProps } from '@progress/kendo-react-grid';
import { CommandDropdownFilterCell } from '../CommandDropdownFilterCell';
import { GetString } from '../StringResourceManager';
import {
  commandStatusStringToTypeMap,
  getCommandStatusOptions,
  commandStatusStringTextMap,
} from '../../utils/textMappings';

export const CommandHistoryDropDownFilterCell: any = (
  props: GridCustomFilterCellProps,
) => (
  <CommandDropdownFilterCell
    {...props}
    data={getCommandStatusOptions()}
    defaultItem={GetString('SELECT_STATUS')}
    onChangeValueCheckFunc={commandStatusStringToTypeMap}
    commandStatusTextMap={commandStatusStringTextMap}
  />
);
